import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const pestApi = createApi({
  reducerPath: "pestApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/pests/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getAllPests: builder.query({
      query: () => ({
        url: "getAll",
        params: {},
        method: "GET",
      }),
    }),
    isValidPest: builder.query({
      query: (pestId) => {
        // const isPestIdInteger = Number.isInteger(Number(pestId));
        // if(!isPestIdInteger) {
        //   return null;
        // }
     
        return {
        url: `check-pest-exists/${pestId}`,
        method: "GET"
      }},
      }),
    getCropsPest: builder.query({
      query: (id) => ({
        url: `getPests/${id}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Pest", id: "List" },
        ...(result ?? []).map((Pest) => ({ type: "Pest", id: Pest.id })),
      ],
    }),
    createPest: builder.mutation({
      query: (pest) => ({
        url: "create",
        body: pest,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Pest", id: "List" },
        { type: "Pest", id: (id) => id },
      ],
    }),
    updatePest: builder.mutation({
      query: (pest) => ({
        url: `updatePest`,
        body: pest,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "Pest", id: "List" },
        { type: "Pest", id: (id) => id },
      ],
    }),
    deletePest: builder.mutation({
      query: (id) => ({
        url: `deletePest/${id}`,
        body: id,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Pest", id: "List" },
        { type: "Pest", id: (id) => id },
      ],
    }),
    deleteUploadedImage: builder.mutation({
      query: (id) => ({
        url: `deleteUploadedImage/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Pest", id: "List" },
        { type: "Pest", id: (id) => id },
      ],
    }),

    // Pest Info Description
    getPestInfoDescription: builder.query({
      query: (pestId) => ({
        url: `getDescription/${pestId}`,
        params: {},
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "PestInfoDescription", id: "List" },
        ...result?.map((PestInfoDescription) => ({
          type: "PestInfoDescription",
          id: PestInfoDescription.id,
        })),
      ],
    }),
    createPestInfoDescription: builder.mutation({
      query: (formData) => {
        return {
          url: "/createDescription",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [
        { type: "PestInfoDescription", id: "List" },
        { type: "PestInfoDescription", id: (id) => id },
      ],
    }),

    updatePestInfoDescription: builder.mutation({
      query: (data) => ({
        url: `updateDescription`,
        body: data,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "PestInfoDescription", id: "List" },
        { type: "PestInfoDescription", id: (id) => id },
      ],
    }),

    deletePestInfoDescription: builder.mutation({
      query: (id) => ({
        url: `deleteDescription/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "PestInfoDescription", id: "List" },
        { type: "PestInfoDescription", id: (id) => id },
      ],
    }),
    deleteUploadedImage: builder.mutation({
      query: (id) => ({
        url: `deleteUploadedImage/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "PestInfoDescription", id: "List" },
        { type: "PestInfoDescription", id: (id) => id },
      ],
    }),
    deleteUploadedImageInPestInfoDescription: builder.mutation({
      query: (id) => ({
        url: `deleteUploadedImage/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "PestInfoDescription", id: "List" },
        { type: "PestInfoDescription", id: (id) => id },
      ],
    }),

    // New Description
    getPestDescription: builder.query({
      query: (dto) => ({
        url: `get-description/${dto.Id}/${dto.Type}`,
        params: {},
        method: "GET",
      }),
      providesTags: (result, error, dto) => [
        { type: "PestDescriptionData", id: dto.Id },
      ],
    }),
    updatePestDescription: builder.mutation({
      query: (dto) => ({
        url: `updated-description`,
        body: dto,
        method: "PUT",
      }),
      // invalidatesTags: [{ type: 'WeedDescription', id: 'List' },
      // { type: 'WeedDescriptionData', id: (id) => id }],
    }),

    getPestImages: builder.query({
      query: (pestId) => ({
        url: `get-pest-images/${pestId}`,
        params: {},
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "PestImage", id: "List" },
        ...result?.map((PestImage) => ({
          type: "PestImage",
          id: PestImage.id,
        })),
      ],
    }),
    updateImageOrder: builder.mutation({
      query: (data) => {
        return {
          url: `/update-image-order`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: [
        { type: "PestImage", id: "List" },
        { type: "PestImage", id: (id) => id },
      ],
    }),
    createPestImage: builder.mutation({
      query: (entity) => {
        return {
          url: `/upload-pest-image/${entity.Id}`,
          method: "POST",
          body: entity.imageFormData,
        };
      },
      invalidatesTags: [
        { type: "PestImage", id: "List" },
        { type: "PestImage", id: (id) => id },
      ],
    }),
    deletePestImage: builder.mutation({
      query: (image) => ({
        url: `/delete-pest-image`,
        body: image,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "PestImage", id: "List" },
        { type: "PestImage", id: (id) => id },
      ],
    }),
  }),
});

export const {
  useGetPestDescriptionQuery,
  useUpdatePestDescriptionMutation,
  useDeleteUploadedImageInPestInfoDescriptionMutation,
  useUpdatePestInfoDescriptionMutation,
  useDeletePestInfoDescriptionMutation,
  useGetPestInfoDescriptionQuery,
  useGetAllPestsQuery,
  useCreatePestInfoDescriptionMutation,
  useGetCropsPestQuery,
  useCreatePestMutation,
  useUpdatePestMutation,
  useDeletePestMutation,
  useDeleteUploadedImageMutation,
  useGetPestImagesQuery,
  useCreatePestImageMutation,
  useDeletePestImageMutation,
  useUpdateImageOrderMutation,
  useIsValidPestQuery
} = pestApi;
